import script from "./SkillsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsTable.vue?vue&type=script&setup=true&lang=js"

import "./SkillsTable.vue?vue&type=style&index=0&id=d83e58ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d83e58ca"]])

export default __exports__